import { INavBaseInjectable } from '@common/services/autoresolveservice';
import { IRwfInjectable } from '@common/rwf';
import { DialogService } from '@services/dialogservice';
import { CompatibilityService } from '@services/compatibilityservice';

/** Hopefully temp ng specific extension to access ng specific Implementation in angularjs scenario */
export interface INavNgInjectable extends INavBaseInjectable {
    "DialogService": DialogService;
    "$c": CompatibilityService;
}
/** Auto Resolve for Injection Util */
export function InjectionResolve<TNames extends keyof INavNgInjectable>($injector: ng.auto.IInjectorService, inject: TNames): INavNgInjectable[TNames];
export function InjectionResolve<TNames extends keyof INavNgInjectable>($injector: ng.auto.IInjectorService, inject: TNames[]): Pick<INavNgInjectable, TNames>;
export function InjectionResolve<TNames extends keyof INavNgInjectable>($injector: ng.auto.IInjectorService, inject: TNames[] | TNames): Pick<INavNgInjectable, TNames> | INavBaseInjectable[TNames] {

    if (typeof inject === "string") {
        return SingleResolve(inject, $injector);
    }
    const result = <Pick<INavNgInjectable, TNames>>{};
    inject.forEach(name => {
        result[name] = SingleResolve(name, $injector);
    });
    return result;
}

export function SingleResolve<TNames extends keyof INavNgInjectable>(tokenName: TNames, $injector: ng.auto.IInjectorService): INavNgInjectable[TNames] {
    const mappedName = MappedInjectable[tokenName];
    if (!mappedName) {
        throw new Error('Invalid InjectionToken ' + name);
    }
    return $injector.get(mappedName);
}

const MappedInjectable: Record<keyof (INavBaseInjectable & IRwfInjectable), string> = {
    $c: 'CompatibilityService',
    NavClient: 'NavClient',
    NavUrl: 'NavUrlService',
    InfomaAppVersion: "InfomaAppVersion",
    RwfSignalR: 'RwfSignalRService',
    NavSettings: 'NavSettings',
    WebApiRoot: 'WebApiRoot',
    RwfBackend: 'RwfBackend',
    Routing: 'Routing',
    RwfBootstrap: 'RwfBootstrap',
    RwfInvoiceData: 'RwfInvoiceData',
    FwfDataService : 'FwfDataService',
    Rwf: 'Rwf',
    RwfUserInteraction: 'RwfUserInteraction',
    RwfAppSettings: 'RwfAppSettings',
    DialogService: 'DialogService',
    RwfApplication : 'KWFApplication'
};
